import SwitchBox from '@/components/Common/SwitchBox';

export default {
  name: 'Service',
  components: { SwitchBox },
  props: {
    services: {
      type: Array,
      default: (() => []),
    },
  },

  data() {
    return {
      servicesArray: null,
      hover: false,
    };
  },

  computed: {},

  methods: {
    showModal(service) {
      this.$EventBus.$emit('Service/TOGGLE_MODAL', (service));
    },
    showModalToStatusChange(service) {
      this.$EventBus.$emit('Service/TOGGLE_MODAL_WITH_STATUS_CHANGE', (service));
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Services/ServiceWrapper/Service/component.js